export var CustomEvents;
(function (CustomEvents) {
    CustomEvents["ToggleVehicleSave"] = "do.toggleVehicleSave";
})(CustomEvents || (CustomEvents = {}));
